export const APP_BAR_HEIGHT = "50px";
export const APP_SUBHEADER_HEIGHT = "48px";
export const APP_BAR_EXTENDED_HEIGHT = "98px";
export const ADMIN_NAVBAR_HEIGHT = "60px";
export const NAV_SIDEBAR_WIDTH = "300px";
